module.exports = __webpack_public_path__ + "static/media/bitmap.3249d32c.png";